export const genderOptions = [
  {
    label: 'Masculino',
    value: 'M'
  },
  {
    label: 'Femenino',
    value: 'F'
  }
];

// Employee.gender se guarda en inglés (Male/Female) en el backend.
// Se usa solo para precargar el select cuando el dato viene de Employee.
export const employeeGenderToCode = {
  Male: 'M',
  Female: 'F'
};
